import { Component, OnInit } from '@angular/core';
// import { Component, HostListener, ElementRef} from '@angular/core';
import {WidgetBaseComponent} from '../widget-base/widget-base.component';
import {MessageGridSelected} from '../../messages/message-grid-selected';

@Component({
  selector: 'dora-grid-title',
  templateUrl: './dora-grid-title.component.html',
  styleUrls: ['./dora-grid-title.component.scss']
})
export class DoraGridTitleComponent extends WidgetBaseComponent {

  private text = '';


  onParameterInjectedFinished(): void {
    super.onParameterInjectedFinished();

    this.messageService.getMessage(this.EventChannel, MessageGridSelected, this.CallerName).subscribe(message => {
      this.text = (message.data as MessageGridSelected).description;
    });
  }
}
